/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/Znqhb16/GetUserInfo', // 获取用户信息
    bind : '/api/Znqhb16/bind', // 绑定大区
    draw_1 : '/api/Znqhb16/Draw', // 抽奖 1 次
    draw_5 : '/api/Znqhb16/Draw5', // 抽奖 5 次
    opt_gift : '/api/Znqhb16/OptGift', // 红包替换
    bind_back : '/api/Znqhb16/BackBind', // 回流邀请绑定
    invite_list : '/api/Znqhb16/BackList', // 邀请列表

    // README moss通用接口
    queryPlayer : '/api/user/getNickName', // 查询玩家信息
    queryVip : '/api/VipJf/Level', // 查询玩家等级
    my_task : '/api/UserTask/GetDict', // 任务列表
    task_apply : '/api/UserTask/RwTaskIds', // 完成任务领奖
    score_info : '/api/Znqhb/Refresh', // 查询积分/红包次数
    record : '/api/gift/userGiftList?pageIndex=1&pageSize=1000&source=2', // 中奖记录
    shop_list : '/api/gift/list?type=2&orderNum=true', // 礼包列表
    score_trade : '/api/VipJf/reward', // 积分兑换（旧配置，保留）
    score_detail : '/api/user/getScoreList?scoreType=0&pageindex=1&pageSize=1000', // 积分明细
    draw_list : '/api/gift/drawList', // 抽奖列表
    rb_info : '/api/user/getScore', // 抽奖次数查询
    share_info : '/api/share/getCode', // 获取邀请码
    share_rate : '/api/share/getrate', // 获取助力比例
    share_apply : '/api/share/reward', // 助力奖励
    invite_info : '/api/share/getNickName', // 查询邀请信息
    bind_web : '/api/share/bindCode', // 绑定邀请码
    account_submit : '/api/user/saveUserAccountInfo', // 提交支付宝账号
    account_info : '/api/user/getUserAccountInfo', // 获取支付宝账号
    sms : '/api/user/sendSms', // 发送短信验证码

    // 历史重复配置：保持原样，避免本次接口地址更新影响既有调用
    share_apply : '/api/share/reward',
    score_trade : '/api/gift/reward', // 积分兑换（当前对象属性实际使用此配置）
}

export const apiUserinfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryPlayer, p);
export const apiLevelQuery = p => get(user_api.queryVip, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiTaskinfo = p => get(user_api.my_task, p);
export const apiScorenfo = p => get(user_api.score_info, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const apiUserRecord = p => get(user_api.score_detail, p);
export const apiDrawRecord = p => get(user_api.record, p);
export const apiShoplist = p => get(user_api.shop_list , p);
export const apiDrawlist = p => get(user_api.draw_list , p);
export const apiDraw_1 = p => post(user_api.draw_1 , p);
export const apiDraw_5 = p => post(user_api.draw_5 , p);
export const apiScoreTrade = p => post(user_api.score_trade , p);
export const apiOptGift = p => post(user_api.opt_gift , p);
export const apiRbInfo = p => get(user_api.rb_info , p);
export const apiShareInfo = p => get(user_api.share_info , p);
export const apiShareRate = p => get(user_api.share_rate , p);
export const apiShareApply = p => post(user_api.share_apply , p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiWebApply = p => post(user_api.bind_web, p);
export const apiBindBack = p => post(user_api.bind_back, p);
export const apiInviteList = p => get(user_api.invite_list, p);
export const apiSms = p => post(user_api.sms , p);
export const apiAccountInfo = p => get(user_api.account_info , p);
export const apiAccountSubmit = p => post(user_api.account_submit , p);
